import { Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { union_type, array_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { some } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { tryPick, append, choose, fold, map } from "../fable_modules/fable-library-js.4.24.0/Array.js";

export class Tree$2 extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Leaf", "Node"];
    }
}

export function Tree$2_$reflection(gen0, gen1) {
    return union_type("Kundeweb.Tree`2", [gen0, gen1], Tree$2, () => [[["Item", gen0]], [["Item1", gen1], ["Item2", array_type(Tree$2_$reflection(gen0, gen1))]]]);
}

export function Tree_isNode(tree) {
    if (tree.tag === 1) {
        return true;
    }
    else {
        return false;
    }
}

export function Tree_isLeaf(tree) {
    if (tree.tag === 1) {
        return false;
    }
    else {
        return true;
    }
}

export function Tree_tryNode(tree) {
    if (tree.tag === 1) {
        return [tree.fields[0], tree.fields[1]];
    }
    else {
        return undefined;
    }
}

export function Tree_tryLeaf(tree) {
    if (tree.tag === 1) {
        return undefined;
    }
    else {
        return some(tree.fields[0]);
    }
}

export function Tree_cata(leafFunc, nodeFunc, tree) {
    if (tree.tag === 1) {
        return nodeFunc(tree.fields[0], map((tree_1) => Tree_cata(leafFunc, nodeFunc, tree_1), tree.fields[1]));
    }
    else {
        return leafFunc(tree.fields[0]);
    }
}

export function Tree_fold(leafFunc, nodeFunc, acc, tree) {
    if (tree.tag === 1) {
        return fold((acc_1, tree_1) => Tree_fold(leafFunc, nodeFunc, acc_1, tree_1), nodeFunc(acc, tree.fields[0]), tree.fields[1]);
    }
    else {
        return leafFunc(acc, tree.fields[0]);
    }
}

export function Tree_map(leafFunc, nodeFunc, tree) {
    if (tree.tag === 1) {
        return new Tree$2(1, [nodeFunc(tree.fields[0]), map((tree_1) => Tree_map(leafFunc, nodeFunc, tree_1), tree.fields[1])]);
    }
    else {
        return new Tree$2(0, [leafFunc(tree.fields[0])]);
    }
}

/**
 * Filter trees, where true in node predicate the whole tree could be removed
 */
export function Tree_filter(leafPred, nodePred, tree) {
    if (tree.tag === 1) {
        const node = tree.fields[0];
        if (nodePred(node)) {
            return new Tree$2(1, [node, choose((tree_1) => Tree_filter(leafPred, nodePred, tree_1), tree.fields[1])]);
        }
        else {
            return undefined;
        }
    }
    else {
        const leaf = tree.fields[0];
        if (leafPred(leaf)) {
            return new Tree$2(0, [leaf]);
        }
        else {
            return undefined;
        }
    }
}

/**
 * Filter leafs with predicate where node predicate is true as well, but do not remove node if it fails, just skip it
 */
export function Tree_filterLeafs(leafPred, nodePred, tree) {
    if (tree.tag === 1) {
        const node = tree.fields[0];
        const leafs = tree.fields[1];
        return new Tree$2(1, [node, nodePred(node) ? choose((tree_1) => Tree_filterLeafs(leafPred, nodePred, tree_1), leafs) : leafs]);
    }
    else {
        const leaf = tree.fields[0];
        if (leafPred(leaf)) {
            return new Tree$2(0, [leaf]);
        }
        else {
            return undefined;
        }
    }
}

export function Tree_append(nodeFunc, newNodes, tree) {
    if (tree.tag === 1) {
        const node = tree.fields[0];
        const leafs = tree.fields[1];
        if (nodeFunc(node)) {
            return new Tree$2(1, [node, append(newNodes, leafs)]);
        }
        else {
            return new Tree$2(1, [node, map((tree_1) => Tree_append(nodeFunc, newNodes, tree_1), leafs)]);
        }
    }
    else {
        return new Tree$2(0, [tree.fields[0]]);
    }
}

export function Tree_appendCata(nodeFunc, newNodes, tree) {
    return Tree_cata((leaf) => (new Tree$2(0, [leaf])), (node, children) => {
        if (nodeFunc(node)) {
            return new Tree$2(1, [node, append(children, newNodes)]);
        }
        else {
            return new Tree$2(1, [node, children]);
        }
    }, tree);
}

export function Tree_tryFind(leafPred, nodePred, tree) {
    if (tree.tag === 1) {
        const node = tree.fields[0];
        const leafs = tree.fields[1];
        if (nodePred(node)) {
            return new Tree$2(1, [node, leafs]);
        }
        else {
            return tryPick((tree_1) => Tree_tryFind(leafPred, nodePred, tree_1), leafs);
        }
    }
    else {
        const leaf = tree.fields[0];
        if (leafPred(leaf)) {
            return new Tree$2(0, [leaf]);
        }
        else {
            return undefined;
        }
    }
}

export function Tree_tryFindNode(pred, tree) {
    if (tree.tag === 1) {
        const node = tree.fields[0];
        if (pred(node)) {
            return some(node);
        }
        else {
            return tryPick((tree_1) => Tree_tryFindNode(pred, tree_1), tree.fields[1]);
        }
    }
    else {
        return undefined;
    }
}

export function Tree_replace(replacement, leafPred, nodePred, tree) {
    if (tree.tag === 1) {
        const node = tree.fields[0];
        if (nodePred(node)) {
            return replacement;
        }
        else {
            return new Tree$2(1, [node, map((tree_1) => Tree_replace(replacement, leafPred, nodePred, tree_1), tree.fields[1])]);
        }
    }
    else {
        const leaf = tree.fields[0];
        if (leafPred(leaf)) {
            return replacement;
        }
        else {
            return new Tree$2(0, [leaf]);
        }
    }
}

export function Tree_update(updateFunc, leafPred, nodePred, tree) {
    if (tree.tag === 1) {
        const node = tree.fields[0];
        const leafs = tree.fields[1];
        if (nodePred(node)) {
            return updateFunc(new Tree$2(1, [node, leafs]));
        }
        else {
            return new Tree$2(1, [node, choose((tree_1) => Tree_update(updateFunc, leafPred, nodePred, tree_1), leafs)]);
        }
    }
    else {
        const leaf = tree.fields[0];
        if (leafPred(leaf)) {
            return updateFunc(new Tree$2(0, [leaf]));
        }
        else {
            return new Tree$2(0, [leaf]);
        }
    }
}

